import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=3c5c1395&"
import script from "./noticeDialog.vue?vue&type=script&lang=js&"
export * from "./noticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports